import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
// import * as actions from "../actions/authActions"

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class App extends React.Component {
    render() {
        return this.props.children

        //     let isPublic = localStorage.getItem("page_token") ? true : false
        //     let loggedIn = !isPublic && localStorage.getItem("api_token")

        //     if (loggedIn && (!this.props.user || !this.props.user.api_token)) {
        //         this.props.actions.getUser()
        //     }
        //     if (loggedIn && !this.props.userRecord._sid) {
        //         this.props.actions.getUserRecord()
        //     }

        //     return (
        //         <div>
        //             <div className={"content " + (isPublic ? " public" : "")}>
        //                 {this.props.children}
        //             </div>
        //         </div>
        //     )
        // }
    }
}

App.propTypes = {
    children: PropTypes.element,
}

function mapStateToProps(state) {
    return {
        // user: state.auth.user,
        // userRecord: state.auth.userRecord,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        // actions: bindActionCreators(actions, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/app/App.js